// Norwegian Bokmål (Norsk Bokmål)
export default {
  nav: {
    home: 'Hjem',
    wall: 'Veggen',
    groups: 'Grupper',
    users: 'Brukere',
    profile: 'Min profil',
    help: 'Hjelp',
    membership: 'Medlemskap',
    logout: 'Logg ut',
    login: 'Logg inn'
  },
  auth: {
    loginSubtitle: 'Logg inn for å fortsette',
    email: 'E-post',
    password: 'Passord',
    noAccount: 'Har du ikke en konto?',
    createAccount: 'Opprett konto',
    loginFailed: 'Innlogging mislyktes. Sjekk e-post og passord.',
    alreadyHaveAccount: 'Har du allerede en konto?',
    register: 'Registrer',
    name: 'Navn',
    confirmPassword: 'Bekreft passord',
    registrationSuccess: 'Konto opprettet! Du kan nå logge inn.',
    registrationFailed: 'Kunne ikke opprette konto.'
  },
  home: {
    title: 'Fellesskap',
    tagline: 'Et rolig sted på nettet – uten reklame.',
    description: 'Del hverdagen med familie, venner og nye bekjente. Ingen støy, ingen sporing, ingen datasalg.',
    features: {
      noAds: 'Reklamefri',
      simple: 'Enkel og tydelig',
      safe: 'Trygg tone + moderering'
    },
    cta: {
      openWall: 'Åpne Veggen',
      createProfile: 'Opprett gratis profil',
      goToWall: 'Gå til Veggen',
      readMore: 'Les om idéen'
    },
    pricing: 'Siden er gratis å bruke.',
    pricingDetail: 'Men selv vi trenger å leve – vennligst vurder å donere.'
  },
  wall: {
    title: 'Veggen',
    subtitle: 'Her ser du innlegg fra fellesskapet.',
    writePost: 'SKRIV PÅ VEGGEN',
    placeholder: 'Skriv ditt innlegg her...',
    group: 'Gruppe',
    noGroup: 'Ingen gruppe',
    selectImage: 'Velg bilde',
    noFileSelected: 'Ingen fil valgt.',
    send: 'Send',
    public: 'Offentlig',
    members: 'Medlemmer',
    private: 'Privat',
    visibility: 'Synlighet'
  },
  groups: {
    title: 'Grupper',
    subtitle: 'Grupper som gir mening – lokalt, hobby, reiser, turer – lett å følge med.',
    createGroup: 'Opprett gruppe',
    allGroups: 'Alle grupper',
    myGroups: 'Mine grupper',
    searchPlaceholder: 'Søk grupper...',
    noGroups: 'Ingen grupper funnet',
    noMyGroups: 'Du er ikke medlem av noen grupper ennå',
    groupName: 'Gruppenavn',
    description: 'Beskrivelse',
    publicGroup: 'Offentlig gruppe (alle kan se og bli med)',
    private: 'Privat',
    createdBy: 'Opprettet av',
    members: 'medlemmer',
    postsCount: 'innlegg',
    noDescription: 'Ingen beskrivelse',
    join: 'Bli med',
    leave: 'Forlat',
    open: 'Åpne',
    leaveConfirm: 'Er du sikker på at du vil forlate denne gruppen?',
    postsTab: 'Innlegg',
    membersTab: 'Medlemmer',
    noPosts: 'Ingen innlegg i denne gruppen ennå',
    joinToSee: 'Bli med i gruppen for å se innlegg',
    about: 'Om gruppen',
    createdOn: 'Opprettet',
    editGroup: 'Rediger gruppe',
    deleteConfirm: 'Er du sikker på at du vil slette denne gruppen? Alle innlegg vil bli slettet.',
    setMember: 'Sett som medlem',
    setModerator: 'Sett som moderator',
    setAdmin: 'Sett som admin',
    removeMember: 'Fjern fra gruppe',
    removeMemberConfirm: 'Er du sikker på at du vil fjerne {name} fra gruppen?',
    changeCover: 'Bytt forsidebilde',
    invalidImageType: 'Ugyldig filtype. Vennligst velg et bilde.',
    imageTooLarge: 'Bildet er for stort. Maksimum 5MB.'
  },
  profile: {
    title: 'Min profil',
    editProfile: 'Rediger profil',
    myPosts: 'Mine innlegg',
    myGroups: 'Mine grupper',
    overview: 'Oversikt',
    edit: 'Rediger',
    settings: 'Innstillinger',
    activity: 'Aktivitet',
    bio: 'Om meg',
    location: 'Sted',
    website: 'Nettside',
    birthday: 'Bursdag',
    interests: 'Interesser',
    joined: 'Ble med',
    posts: 'Innlegg',
    comments: 'Kommentarer',
    reactions: 'Reaksjoner',
    privacy: 'Personvern',
    showRealName: 'Vis ekte navn offentlig',
    showEmail: 'Vis e-post offentlig',
    emailNotifications: 'E-postvarsler',
    changePassword: 'Bytt passord',
    currentPassword: 'Nåværende passord',
    newPassword: 'Nytt passord',
    confirmPassword: 'Bekreft passord',
    uploadAvatar: 'Last opp profilbilde',
    changeAvatar: 'Bytt profilbilde',
    removeAvatar: 'Fjern profilbilde',
    bioPlaceholder: 'Fortell litt om deg selv...',
    interestsPlaceholder: 'Hva er du interessert i?',
    saveChanges: 'Lagre endringer',
    cancelChanges: 'Avbryt',
    profileUpdated: 'Profil oppdatert!',
    passwordChanged: 'Passord endret!',
    avatarUploaded: 'Profilbilde lastet opp!',
    recentPosts: 'Siste innlegg',
    recentComments: 'Siste kommentarer',
    recentReactions: 'Siste reaksjoner',
    noPosts: 'Ingen innlegg ennå',
    noComments: 'Ingen kommentarer ennå',
    noReactions: 'Ingen reaksjoner ennå',
    downloadData: 'Last ned mine data',
    deleteAccount: 'Slett konto',
    deleteAccountWarning: 'Dette vil permanent slette kontoen din og all data. Denne handlingen kan ikke angres.',
    age: 'år'
  },
  common: {
    loading: 'Laster...',
    error: 'En feil oppstod',
    success: 'Vellykket!',
    cancel: 'Avbryt',
    save: 'Lagre',
    delete: 'Slett',
    edit: 'Rediger',
    post: 'Send',
    comment: 'Kommentar',
    quote: 'Siter',
    reply: 'Svar',
    confirm: 'Bekreft',
    ok: 'OK',
    data: 'Data',
    noComments: 'Ingen kommentarer ennå. Vær den første!',
    writeComment: 'Skriv en kommentar...',
    replyToComment: 'Svar på kommentar...',
    deleteConfirm: 'Slette dette innlegget?',
    contentRequired: 'Innholdet kan ikke være tomt',
    updateFailed: 'Kunne ikke oppdatere innlegg',
    deleteFailed: 'Kunne ikke slette innlegg',
    commentFailed: 'Kunne ikke sende kommentar'
  },
  users: {
    searchTitle: 'Finn brukere',
    searchSubtitle: 'Søk etter brukere i fellesskapet',
    searchPlaceholder: 'Søk etter brukernavn, navn eller e-post...',
    search: 'Søk',
    searchHint: 'Skriv inn minst 2 tegn for å søke etter brukere',
    resultsFound: '{count} bruker(e) funnet',
    noResults: 'Ingen brukere funnet. Prøv et annet søkeord.'
  },
  validation: {
    required: 'Dette feltet er påkrevd',
    email: 'Skriv inn en gyldig e-postadresse',
    maxLength: 'Maks {max} tegn',
    passwordMatch: 'Passordene må være like'
  }
}
